// src/forms.ts
var MESSAGE = {
  REQUIRED: (value = null) => value ? `The ${value} field is required.` : "This is a required field.",
  NAME_VALID: (value) => `Please enter a valid ${value}`,
  MAX: (value) => `Cannot be more than ${value} characters`,
  CONFIRM_PASS: "Please enter the password again.",
  EMAIL_VALID: "Please enter a valid email.",
  PHONE_VALID: "Phone number is not valid.",
  NUMBER_VALID: "Please provide a number.",
  ZIPCOD_VALID: "Zipcode is not valid.",
  ACCOUNT_VALID: "Enter a valid US bank account number.",
  ACCOUNT_MATCH: "Account number must match.",
  ACH_VALID: "Enter a valid ACH routing number.",
  ACH_MATCH: "ACH routing number must match.",
  COMPANY_NAME_VALID: "Provide a valid company name.",
  DECIMAL_VALID: "Value should not be in decimal format.",
  URL_VALID: "URL is not valid",
  MIN_VALID: "Please provide value more than 0"
};
export {
  MESSAGE
};
//# sourceMappingURL=forms.mjs.map